import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { RequestEmployeeResponse } from "@/types";

async function createNewEmployee(
  request: FormData
): Promise<RequestEmployeeResponse> {
  const response = await httpRequest.post(`/employees`, request, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export function useCreateEmployeeMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createNewEmployee,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["employees"] });
    },
  });
}
